export default "__VITE_ASSET__DBkugLic__"